import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Typography} from 'views/components';
import {AutoAwesome as GenerateIcon} from 'views/icons';
import {Translate, translate} from 'views/module';

import GenerateJobDialog from './GenerateJobDialog';

import backend from 'utils/backend';

const GenerateJobButton = (props) => {
  const {onGenerated} = props;
  const progressWrap = props.statusProgressWrap;

  const [open, setOpen] = React.useState(false);

  const errorMessage = (error) => {
    const handledErrors = ['CLT_001', 'JOB_003', 'JOB_006', 'JOB_007', 'JOB_008', 'JOB_009', 'JOB_010'];

    return translate(`job.ClientJobs.Errors.${handledErrors.includes(error.code) ? error.code : 'Default'}`);
  };

  const generate = (guidance, client) => {
    return progressWrap(async () => {
      const result = await backend.loom.job.generateJob(client.clientId, {
        guidance: guidance.trim() || null,
      });
      setOpen(false);
      onGenerated(result);
    }, {
      onSuccessMessage: translate('job.ClientJobs.GenerateDialog.Generated', {clientName: client.clientName}),
      onErrorMessage: errorMessage,
      debugString: 'JOB_LIST_GENERATE',
    });
  };

  return (
    <>
      <Button
        variant='outlined'
        startIcon={<GenerateIcon sx={{fontSize: '14px'}} />}
        onClick={() => setOpen(true)}
        sx={{
          'minWidth': '64px',
          'height': '32px',
          'px': '10px',
          'py': '8px',
          'borderRadius': '7px',
          'borderColor': '#DA7955',
          'backgroundColor': '#FFFFFF',
          'color': '#DA7955',
          'textTransform': 'none',
          'boxShadow': 'none',
          '&:hover': {
            'borderColor': '#C96D4B',
            'backgroundColor': '#FBF1EC',
            'boxShadow': 'none',
          },
        }}
      >
        <Typography
          sx={{
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '12px',
            color: 'inherit',
          }}
        >
          <Translate expression='job.ClientJobs.Generate' />
        </Typography>
      </Button>
      {
        open &&
        <GenerateJobDialog
          selectClient
          onClose={() => setOpen(false)}
          onGenerate={generate}
        />
      }
    </>
  );
};

GenerateJobButton.propTypes = {
  onGenerated: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(GenerateJobButton));
